export const MARKETPLACE_DATE_RANGES = [
  { value: "today", label: "Hoy" },
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
];

export const DEFAULT_MARKETPLACE_RANGE = "last_30_days";

export const CITY_SUPPLY_DEMAND_LABELS = {
  high_demand_low_supply: "Alta demanda, baja oferta",
  healthy: "Equilibrado",
  high_supply_low_demand: "Alta oferta, baja demanda",
  low_activity: "Baja actividad",
  insufficient_data: "Datos insuficientes",
};

export function trackMarketplaceAnalyticsEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[marketplace-analytics-event]", eventType, metadata);
  }
}

export function formatPercent(value) {
  if (value == null) return "—";
  return `${value}%`;
}
